import { ETheme, EThemeColor } from "@/common/entity/Enum";
import { renderColorPrimary } from "@/common/function/FunctionTheme";
import { ETypeNotify } from "@/services/notification-service/entity/NotificationEntity";

export interface IIconProps {
  theme?: string | null;
  isActive?: boolean;
  isDisable?: boolean;
  color?: string;
}

export const ExpandOpenSmall: React.FC<{
  onClick?: React.MouseEventHandler<HTMLElement>;
}> = ({ onClick }) => {
  return (
    <div
      onClick={onClick}
      style={{ cursor: "pointer", display: "flex", alignItems: "center" }}
    >
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.15391 6.19665C3.11469 6.15898 3.11469 6.09625 3.15391 6.05858L3.58096 5.64841C3.618 5.61282 3.67653 5.61282 3.71357 5.64841L7.68239 9.46042C7.71944 9.496 7.77797 9.496 7.81501 9.46042L11.7838 5.64841C11.8209 5.61282 11.8794 5.61282 11.9165 5.64841L12.3435 6.05858C12.3827 6.09625 12.3827 6.15898 12.3435 6.19665L7.81501 10.5462C7.77797 10.5818 7.71944 10.5818 7.68239 10.5462L3.15391 6.19665Z"
          fill="#616161"
        />
      </svg>
    </div>
  );
};

export const ExpandOpen: React.FC<{
  onClick?: React.MouseEventHandler<HTMLElement>;
}> = ({ onClick }) => {
  return (
    <div onClick={onClick} style={{ cursor: "pointer" }}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        transform="rotate(180)"
      >
        <path
          d="M3.94238 7.74539C3.89336 7.6983 3.89336 7.61989 3.94238 7.5728L4.47619 7.06008C4.5225 7.0156 4.59566 7.0156 4.64196 7.06008L9.60299 11.8251C9.6493 11.8696 9.72246 11.8696 9.76876 11.8251L14.7298 7.06008C14.7761 7.0156 14.8493 7.0156 14.8956 7.06008L15.4294 7.5728C15.4784 7.61989 15.4784 7.6983 15.4294 7.74539L9.76876 13.1823C9.72246 13.2268 9.6493 13.2268 9.60299 13.1823L3.94238 7.74539Z"
          fill="#616161"
        />
      </svg>
    </div>
  );
};

export const ExpandCloseSmall: React.FC<{
  onClick?: React.MouseEventHandler<HTMLElement>;
}> = ({ onClick }) => {
  return (
    <div
      onClick={onClick}
      style={{ cursor: "pointer", display: "flex", alignItems: "center" }}
    >
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.15391 6.19665C3.11469 6.15898 3.11469 6.09625 3.15391 6.05858L3.58096 5.64841C3.618 5.61282 3.67653 5.61282 3.71357 5.64841L7.68239 9.46042C7.71944 9.496 7.77797 9.496 7.81501 9.46042L11.7838 5.64841C11.8209 5.61282 11.8794 5.61282 11.9165 5.64841L12.3435 6.05858C12.3827 6.09625 12.3827 6.15898 12.3435 6.19665L7.81501 10.5462C7.77797 10.5818 7.71944 10.5818 7.68239 10.5462L3.15391 6.19665Z"
          fill="#616161"
        />
      </svg>
    </div>
  );
};

export const ExpandClose: React.FC<{
  onClick?: React.MouseEventHandler<HTMLElement>;
}> = ({ onClick }) => {
  return (
    <div
      onClick={onClick}
      style={{ cursor: "pointer", display: "flex", alignItems: "center" }}
    >
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.94238 7.74539C3.89336 7.6983 3.89336 7.61989 3.94238 7.5728L4.47619 7.06008C4.5225 7.0156 4.59566 7.0156 4.64196 7.06008L9.60299 11.8251C9.6493 11.8696 9.72246 11.8696 9.76876 11.8251L14.7298 7.06008C14.7761 7.0156 14.8493 7.0156 14.8956 7.06008L15.4294 7.5728C15.4784 7.61989 15.4784 7.6983 15.4294 7.74539L9.76876 13.1823C9.72246 13.2268 9.6493 13.2268 9.60299 13.1823L3.94238 7.74539Z"
          fill="#616161"
        />
      </svg>
    </div>
  );
};

export const LocationIcon = (props: IIconProps) => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 1.125C9.69239 1.125 11.875 3.30761 11.875 6C11.875 8.05982 10.4277 10.3046 7.5701 12.7589C7.2422 13.0405 6.75779 13.0405 6.42858 12.7578L6.23971 12.5941C3.50856 10.2044 2.125 8.01391 2.125 6C2.125 3.30761 4.30761 1.125 7 1.125ZM7 1.875C4.72183 1.875 2.875 3.72183 2.875 6C2.875 7.75103 4.1492 9.7684 6.73227 12.0285L6.91855 12.19C6.96539 12.2302 7.0346 12.2302 7.08144 12.19C9.78946 9.86416 11.125 7.79267 11.125 6C11.125 3.72183 9.27817 1.875 7 1.875ZM7 4.125C8.03553 4.125 8.875 4.96447 8.875 6C8.875 7.03553 8.03553 7.875 7 7.875C5.96447 7.875 5.125 7.03553 5.125 6C5.125 4.96447 5.96447 4.125 7 4.125ZM7 4.875C6.37868 4.875 5.875 5.37868 5.875 6C5.875 6.62132 6.37868 7.125 7 7.125C7.62132 7.125 8.125 6.62132 8.125 6C8.125 5.37868 7.62132 4.875 7 4.875Z"
        fill={
          props.theme === ETheme.Dark
            ? EThemeColor.ColorNeutralForeground1Dark
            : "#616161"
        }
      />
    </svg>
  );
};

export const LocationIconActive = (props: IIconProps) => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 1.125C9.69239 1.125 11.875 3.30761 11.875 6C11.875 8.05982 10.4277 10.3046 7.5701 12.7589C7.2422 13.0405 6.75779 13.0405 6.42858 12.7578L6.23971 12.5941C3.50856 10.2044 2.125 8.01391 2.125 6C2.125 3.30761 4.30761 1.125 7 1.125ZM7 4.125C5.96447 4.125 5.125 4.96447 5.125 6C5.125 7.03553 5.96447 7.875 7 7.875C8.03553 7.875 8.875 7.03553 8.875 6C8.875 4.96447 8.03553 4.125 7 4.125Z"
        fill={renderColorPrimary(props.theme)}
      />
    </svg>
  );
};
export const LocationIconMaker = (props: IIconProps) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.9497 13.955C17.6834 11.2201 17.6834 6.78601 14.9497 4.05115C12.2161 1.31628 7.78392 1.31628 5.05025 4.05115C2.31658 6.78601 2.31658 11.2201 5.05025 13.955L6.57128 15.4538L8.61408 17.4389L8.74691 17.5567C9.52168 18.1847 10.6562 18.1455 11.3861 17.4391L13.8223 15.0691L14.9497 13.955ZM10 12C8.34315 12 7 10.6569 7 9C7 7.34315 8.34315 6 10 6C11.6569 6 13 7.34315 13 9C13 10.6569 11.6569 12 10 12Z"
        fill="#106EBE"
      />
    </svg>
  );
};

export const HelpIcon = (props: IIconProps) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0ZM8 11.5C7.58579 11.5 7.25 11.8358 7.25 12.25C7.25 12.6642 7.58579 13 8 13C8.41421 13 8.75 12.6642 8.75 12.25C8.75 11.8358 8.41421 11.5 8 11.5ZM8 3.5C6.61929 3.5 5.5 4.61929 5.5 6C5.5 6.27614 5.72386 6.5 6 6.5C6.27614 6.5 6.5 6.27614 6.5 6C6.5 5.17157 7.17157 4.5 8 4.5C8.82843 4.5 9.5 5.17157 9.5 6C9.5 6.36931 9.36602 6.71582 9.13195 6.98447L9.02561 7.09468L8.90761 7.19439L8.66094 7.37874C8.53202 7.47988 8.41649 7.5832 8.30535 7.70162C7.79312 8.24747 7.5 8.98796 7.5 10C7.5 10.2761 7.72386 10.5 8 10.5C8.27614 10.5 8.5 10.2761 8.5 10C8.5 9.24223 8.69627 8.74641 9.03456 8.38592L9.11003 8.30994L9.19065 8.23718L9.27817 8.16553L9.49667 8.00243L9.6513 7.8771C10.1848 7.40774 10.5 6.72959 10.5 6C10.5 4.61929 9.38071 3.5 8 3.5Z"
        fill="#0078D4"
      />
    </svg>
  );
};
export const CategoryIcon = (props: IIconProps) => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.33331 2.3335H5.83331V5.8335H2.33331V2.3335ZM8.16665 2.3335H11.6666V5.8335H8.16665V2.3335ZM2.33331 8.16683H5.83331V11.6668H2.33331V8.16683ZM8.16665 9.91683C8.16665 10.381 8.35102 10.8261 8.67921 11.1543C9.0074 11.4825 9.45252 11.6668 9.91665 11.6668C10.3808 11.6668 10.8259 11.4825 11.1541 11.1543C11.4823 10.8261 11.6666 10.381 11.6666 9.91683C11.6666 9.4527 11.4823 9.00758 11.1541 8.67939C10.8259 8.3512 10.3808 8.16683 9.91665 8.16683C9.45252 8.16683 9.0074 8.3512 8.67921 8.67939C8.35102 9.00758 8.16665 9.4527 8.16665 9.91683Z"
        stroke={
          props.theme === ETheme.Dark
            ? EThemeColor.ColorNeutralForeground1Dark
            : "#616161"
        }
        strokeWidth="0.583333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const CategoryIconActive = (props: IIconProps) => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_4611_5972)">
        <path
          d="M5.83333 1.75H2.33333C2.17862 1.75 2.03025 1.81146 1.92085 1.92085C1.81146 2.03025 1.75 2.17862 1.75 2.33333V5.83333C1.75 5.98804 1.81146 6.13642 1.92085 6.24581C2.03025 6.35521 2.17862 6.41667 2.33333 6.41667H5.83333C5.98804 6.41667 6.13642 6.35521 6.24581 6.24581C6.35521 6.13642 6.41667 5.98804 6.41667 5.83333V2.33333C6.41667 2.17862 6.35521 2.03025 6.24581 1.92085C6.13642 1.81146 5.98804 1.75 5.83333 1.75ZM11.6667 1.75H8.16667C8.01196 1.75 7.86358 1.81146 7.75419 1.92085C7.64479 2.03025 7.58333 2.17862 7.58333 2.33333V5.83333C7.58333 5.98804 7.64479 6.13642 7.75419 6.24581C7.86358 6.35521 8.01196 6.41667 8.16667 6.41667H11.6667C11.8214 6.41667 11.9697 6.35521 12.0791 6.24581C12.1885 6.13642 12.25 5.98804 12.25 5.83333V2.33333C12.25 2.17862 12.1885 2.03025 12.0791 1.92085C11.9697 1.81146 11.8214 1.75 11.6667 1.75ZM5.83333 7.58333H2.33333C2.17862 7.58333 2.03025 7.64479 1.92085 7.75419C1.81146 7.86358 1.75 8.01196 1.75 8.16667V11.6667C1.75 11.8214 1.81146 11.9697 1.92085 12.0791C2.03025 12.1885 2.17862 12.25 2.33333 12.25H5.83333C5.98804 12.25 6.13642 12.1885 6.24581 12.0791C6.35521 11.9697 6.41667 11.8214 6.41667 11.6667V8.16667C6.41667 8.01196 6.35521 7.86358 6.24581 7.75419C6.13642 7.64479 5.98804 7.58333 5.83333 7.58333ZM9.91667 7.58333C10.3732 7.58333 10.8197 7.71725 11.2008 7.9685C11.582 8.21976 11.8811 8.5773 12.061 8.99685C12.241 9.4164 12.2939 9.87953 12.2133 10.3289C12.1326 10.7782 11.922 11.194 11.6073 11.5248C11.2927 11.8556 10.8879 12.0868 10.4432 12.1898C9.99844 12.2928 9.53324 12.2631 9.10522 12.1044C8.67719 11.9456 8.30514 11.6648 8.03515 11.2966C7.76515 10.9285 7.60908 10.4893 7.58625 10.0333L7.58333 9.91667L7.58625 9.8C7.61618 9.20211 7.87477 8.63859 8.30853 8.22601C8.74228 7.81342 9.31803 7.58333 9.91667 7.58333Z"
          fill={renderColorPrimary(props.theme)}
        />
      </g>
      <defs>
        <clipPath id="clip0_4611_5972">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const RenderIconCalendar = (props: IIconProps) => {
  return (
    <svg
      className="calendar"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.24848 8.99696C5.66186 8.99696 5.99696 8.66186 5.99696 8.24848C5.99696 7.83511 5.66186 7.5 5.24848 7.5C4.83511 7.5 4.5 7.83511 4.5 8.24848C4.5 8.66186 4.83511 8.99696 5.24848 8.99696ZM5.99696 10.7485C5.99696 11.1619 5.66186 11.497 5.24848 11.497C4.83511 11.497 4.5 11.1619 4.5 10.7485C4.5 10.3351 4.83511 10 5.24848 10C5.66186 10 5.99696 10.3351 5.99696 10.7485ZM8.00043 8.99696C8.41381 8.99696 8.74892 8.66186 8.74892 8.24848C8.74892 7.83511 8.41381 7.5 8.00043 7.5C7.58706 7.5 7.25195 7.83511 7.25195 8.24848C7.25195 8.66186 7.58706 8.99696 8.00043 8.99696ZM8.74892 10.7485C8.74892 11.1619 8.41381 11.497 8.00043 11.497C7.58706 11.497 7.25195 11.1619 7.25195 10.7485C7.25195 10.3351 7.58706 10 8.00043 10C8.41381 10 8.74892 10.3351 8.74892 10.7485ZM10.7485 8.99696C11.1619 8.99696 11.497 8.66186 11.497 8.24848C11.497 7.83511 11.1619 7.5 10.7485 7.5C10.3351 7.5 10 7.83511 10 8.24848C10 8.66186 10.3351 8.99696 10.7485 8.99696ZM14 4.5C14 3.11929 12.8807 2 11.5 2H4.5C3.11929 2 2 3.11929 2 4.5V11.5C2 12.8807 3.11929 14 4.5 14H11.5C12.8807 14 14 12.8807 14 11.5V4.5ZM3 6H13V11.5C13 12.3284 12.3284 13 11.5 13H4.5C3.67157 13 3 12.3284 3 11.5V6ZM4.5 3H11.5C12.3284 3 13 3.67157 13 4.5V5H3V4.5C3 3.67157 3.67157 3 4.5 3Z"
        fill={
          props.theme === ETheme.Dark
            ? EThemeColor.ColorNeutralForeground1Dark
            : "#424242"
        }
      />
    </svg>
  );
};

export const RenderIconInfo = (props: IIconProps) => {
  return (
    <svg
      className="info"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.0018 5.2461C8.0018 5.53582 7.76693 5.77068 7.47721 5.77068C7.18749 5.77068 6.95262 5.53582 6.95262 5.2461C6.95262 4.95638 7.18749 4.72152 7.47721 4.72152C7.76693 4.72152 8.0018 4.95638 8.0018 5.2461ZM7.08377 7.21327L7.08377 11.1476C7.08377 11.3649 7.25992 11.541 7.47721 11.541C7.6945 11.541 7.87065 11.3649 7.87065 11.1476L7.87065 7.21327C7.87065 6.99598 7.6945 6.81983 7.47721 6.81983C7.25992 6.81983 7.08377 6.99598 7.08377 7.21327ZM1.18213 8.39357C1.18213 4.91697 4.00053 2.09863 7.47721 2.09863C10.9539 2.09863 13.7723 4.91697 13.7723 8.39357C13.7723 11.8702 10.9539 14.6885 7.47721 14.6885C4.00053 14.6885 1.18213 11.8702 1.18213 8.39357ZM7.47721 2.8855C4.43512 2.8855 1.96901 5.35154 1.96901 8.39357C1.96901 11.4356 4.43512 13.9016 7.47721 13.9016C10.5193 13.9016 12.9854 11.4356 12.9854 8.39357C12.9854 5.35154 10.5193 2.8855 7.47721 2.8855Z"
        fill={
          props.theme === ETheme.Dark
            ? EThemeColor.ColorNeutralForeground1Dark
            : EThemeColor.IconLightGey
        }
      />
    </svg>
  );
};

export const RenderIconStar = (props: IIconProps) => {
  const renderColor = (): string => {
    if (!props.isActive && props.theme === ETheme.Dark) {
      return EThemeColor.ColorNeutralForeground1Dark;
    } else if (props.isActive && props.theme === ETheme.Dark) {
      return EThemeColor.ColorNeutralForeground2BrandSelectedDark;
    } else if (props.isActive) {
      return EThemeColor.ColorNeutralForeground2BrandSelectedLight;
    }
    return EThemeColor.IconLightGey;
  };

  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.1939 2.10203C7.52403 1.43311 8.47789 1.43311 8.80802 2.10203L10.3291 5.18409L13.7304 5.67832C14.4685 5.78558 14.7633 6.69276 14.2291 7.21344L11.768 9.61248L12.349 13C12.4751 13.7352 11.7034 14.2959 11.0431 13.9487L8.00096 12.3494L4.95879 13.9487C4.29853 14.2959 3.52684 13.7352 3.65294 13L4.23394 9.61248L1.77277 7.21344C1.23861 6.69276 1.53336 5.78558 2.27156 5.67832L5.67281 5.18409L7.1939 2.10203ZM8.00096 2.7263L6.54628 5.6738C6.41519 5.93942 6.16178 6.12354 5.86864 6.16613L2.61588 6.63879L4.9696 8.93309C5.18171 9.13986 5.27851 9.43776 5.22843 9.72971L4.6728 12.9693L7.58215 11.4398C7.84434 11.3019 8.15758 11.3019 8.41977 11.4398L11.3291 12.9693L10.7735 9.72971C10.7234 9.43776 10.8202 9.13986 11.0323 8.93309L13.386 6.63879L10.1333 6.16613C9.84014 6.12354 9.58673 5.93942 9.45564 5.6738L8.00096 2.7263Z"
        fill={renderColor()}
      />
    </svg>
  );
};

export const RenderIconDismiss = (props: IIconProps) => {
  return (
    <svg
      className="dismiss"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.58859 2.71569L2.64645 2.64645C2.82001 2.47288 3.08944 2.4536 3.28431 2.58859L3.35355 2.64645L8 7.293L12.6464 2.64645C12.8417 2.45118 13.1583 2.45118 13.3536 2.64645C13.5488 2.84171 13.5488 3.15829 13.3536 3.35355L8.707 8L13.3536 12.6464C13.5271 12.82 13.5464 13.0894 13.4114 13.2843L13.3536 13.3536C13.18 13.5271 12.9106 13.5464 12.7157 13.4114L12.6464 13.3536L8 8.707L3.35355 13.3536C3.15829 13.5488 2.84171 13.5488 2.64645 13.3536C2.45118 13.1583 2.45118 12.8417 2.64645 12.6464L7.293 8L2.64645 3.35355C2.47288 3.17999 2.4536 2.91056 2.58859 2.71569L2.64645 2.64645L2.58859 2.71569Z"
        fill={
          props.theme === ETheme.Dark
            ? EThemeColor.ColorNeutralForeground1Dark
            : EThemeColor.IconLightGey
        }
      />
    </svg>
  );
};

export const RenderIconDismissSmall = (props: IIconProps) => {
  return (
    <svg
      className="dismiss"
      width="14"
      height="14"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.58859 2.71569L2.64645 2.64645C2.82001 2.47288 3.08944 2.4536 3.28431 2.58859L3.35355 2.64645L8 7.293L12.6464 2.64645C12.8417 2.45118 13.1583 2.45118 13.3536 2.64645C13.5488 2.84171 13.5488 3.15829 13.3536 3.35355L8.707 8L13.3536 12.6464C13.5271 12.82 13.5464 13.0894 13.4114 13.2843L13.3536 13.3536C13.18 13.5271 12.9106 13.5464 12.7157 13.4114L12.6464 13.3536L8 8.707L3.35355 13.3536C3.15829 13.5488 2.84171 13.5488 2.64645 13.3536C2.45118 13.1583 2.45118 12.8417 2.64645 12.6464L7.293 8L2.64645 3.35355C2.47288 3.17999 2.4536 2.91056 2.58859 2.71569L2.64645 2.64645L2.58859 2.71569Z"
        fill={
          props.theme === ETheme.Dark
            ? EThemeColor.ColorNeutralForeground1Dark
            : EThemeColor.IconLightGey
        }
      />
    </svg>
  );
};

export const RenderIconNarrowRight = (props: IIconProps) => {
  return (
    <svg
      width="7"
      height="13"
      viewBox="0 0 7 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.745388 12.0576C0.698302 12.1066 0.619885 12.1066 0.572799 12.0576L0.0600792 11.5238C0.015602 11.4775 0.015602 11.4043 0.0600791 11.358L4.82509 6.39701C4.86957 6.3507 4.86957 6.27754 4.82509 6.23124L0.0600786 1.27021C0.0156015 1.2239 0.0156015 1.15074 0.0600786 1.10444L0.572798 0.570626C0.619885 0.521604 0.698302 0.521603 0.745388 0.570626L6.18234 6.23124C6.22682 6.27754 6.22682 6.3507 6.18234 6.39701L0.745388 12.0576Z"
        fill={renderColorPrimary(props.theme)}
      />
    </svg>
  );
};

export const SelectedResourceIcon = (props: IIconProps) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 3C4.34315 3 3 4.34315 3 6V14C3 15.6569 4.34315 17 6 17H14C15.6569 17 17 15.6569 17 14V6C17 4.34315 15.6569 3 14 3H6ZM13.8536 7.85355L8.85355 12.8536C8.65829 13.0488 8.34171 13.0488 8.14645 12.8536L6.14645 10.8536C5.95118 10.6583 5.95118 10.3417 6.14645 10.1464C6.34171 9.95118 6.65829 9.95118 6.85355 10.1464L8.5 11.7929L13.1464 7.14645C13.3417 6.95118 13.6583 6.95118 13.8536 7.14645C14.0488 7.34171 14.0488 7.65829 13.8536 7.85355Z"
        fill={renderColorPrimary(props.theme)}
      />
    </svg>
  );
};

export const ListResourceIcon = (props: IIconProps) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.5 3C11.5376 3 14 5.46243 14 8.5C14 9.74832 13.5841 10.8995 12.8834 11.8226L17.0303 15.9697C17.3232 16.2626 17.3232 16.7374 17.0303 17.0303C16.7641 17.2966 16.3474 17.3208 16.0538 17.1029L15.9697 17.0303L11.8226 12.8834C10.8995 13.5841 9.74832 14 8.5 14C5.46243 14 3 11.5376 3 8.5C3 5.46243 5.46243 3 8.5 3ZM8.5 4.5C6.29086 4.5 4.5 6.29086 4.5 8.5C4.5 10.7091 6.29086 12.5 8.5 12.5C10.7091 12.5 12.5 10.7091 12.5 8.5C12.5 6.29086 10.7091 4.5 8.5 4.5Z"
        fill={renderColorPrimary(props.theme)}
      />
    </svg>
  );
};

export const RenderIconHome = (props: IIconProps) => {
  const renderColor = (): string => {
    if (!props.isActive && props.theme === ETheme.Dark) {
      return EThemeColor.ColorNeutralForeground1Dark;
    } else if (props.isActive && props.theme === ETheme.Dark) {
      return EThemeColor.ColorNeutralForeground2BrandSelectedDark;
    } else if (props.isActive) {
      return EThemeColor.ColorNeutralForeground2BrandSelectedLight;
    }
    return EThemeColor.IconLightGey;
  };

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.5495 2.53189C11.3874 1.82531 12.6126 1.82531 13.4505 2.5319L20.2005 8.224C20.7074 8.65152 21 9.2809 21 9.94406V19.7468C21 20.7133 20.2165 21.4968 19.25 21.4968H15.75C14.7835 21.4968 14 20.7133 14 19.7468V14.2468C14 14.1088 13.8881 13.9968 13.75 13.9968H10.25C10.1119 13.9968 9.99999 14.1088 9.99999 14.2468V19.7468C9.99999 20.7133 9.2165 21.4968 8.25 21.4968H4.75C3.7835 21.4968 3 20.7133 3 19.7468V9.94406C3 9.2809 3.29255 8.65152 3.79952 8.224L10.5495 2.53189ZM12.4835 3.6786C12.2042 3.44307 11.7958 3.44307 11.5165 3.6786L4.76651 9.37071C4.59752 9.51321 4.5 9.72301 4.5 9.94406V19.7468C4.5 19.8849 4.61193 19.9968 4.75 19.9968H8.25C8.38807 19.9968 8.49999 19.8849 8.49999 19.7468V14.2468C8.49999 13.2803 9.2835 12.4968 10.25 12.4968H13.75C14.7165 12.4968 15.5 13.2803 15.5 14.2468V19.7468C15.5 19.8849 15.6119 19.9968 15.75 19.9968H19.25C19.3881 19.9968 19.5 19.8849 19.5 19.7468V9.94406C19.5 9.72301 19.4025 9.51321 19.2335 9.37071L12.4835 3.6786Z"
        fill={renderColor()}
      />
    </svg>
  );
};

export const RenderIconResource = (props: IIconProps) => {
  const renderColor = (): string => {
    if (!props.isActive && props.theme === ETheme.Dark) {
      return EThemeColor.ColorNeutralForeground1Dark;
    } else if (props.isActive && props.theme === ETheme.Dark) {
      return EThemeColor.ColorNeutralForeground2BrandSelectedDark;
    } else if (props.isActive) {
      return EThemeColor.ColorNeutralForeground2BrandSelectedLight;
    }
    return EThemeColor.IconLightGey;
  };

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.5 6.75H17V5.5C17 4.13281 15.8672 3 14.5 3H9.5C8.09375 3 7 4.13281 7 5.5V6.75H4.5C3.09375 6.75 2 7.88281 2 9.25V19.25C2 20.6562 3.09375 21.75 4.5 21.75H19.5C20.8672 21.75 22 20.6562 22 19.25V9.25C22 7.88281 20.8672 6.75 19.5 6.75ZM9.5 4.875H14.5C14.8125 4.875 15.125 5.1875 15.125 5.5V6.75H8.875V5.5C8.875 5.1875 9.14844 4.875 9.5 4.875ZM4.5 8.625H19.5C19.8125 8.625 20.125 8.9375 20.125 9.25V13H3.875V9.25C3.875 8.9375 4.14844 8.625 4.5 8.625ZM19.5 19.875H4.5C4.14844 19.875 3.875 19.6016 3.875 19.25V14.875H9.5V15.5C9.5 16.2031 10.0469 16.75 10.75 16.75H13.25C13.9141 16.75 14.5 16.2031 14.5 15.5V14.875H20.125V19.25C20.125 19.6016 19.8125 19.875 19.5 19.875Z"
        fill={renderColor()}
      />
    </svg>
  );
};

export const RenderIconColleague = (props: IIconProps) => {
  const renderColor = (): string => {
    if (!props.isActive && props.theme === ETheme.Dark) {
      return EThemeColor.ColorNeutralForeground1Dark;
    } else if (props.isActive && props.theme === ETheme.Dark) {
      return EThemeColor.ColorNeutralForeground2BrandSelectedDark;
    } else if (props.isActive) {
      return EThemeColor.ColorNeutralForeground2BrandSelectedLight;
    }
    return EThemeColor.IconLightGey;
  };

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.8639 11.6111C14.2698 11.6111 14.5989 11.9402 14.5989 12.3461V12.7877C14.5989 14.1337 13.2946 15.7303 10.7732 15.7303C8.25183 15.7303 6.94758 14.1337 6.94758 12.7877V12.3461C6.94758 11.9402 7.27666 11.6111 7.68259 11.6111H13.8639ZM10.7732 5.87129C11.7888 5.87129 12.612 6.69456 12.612 7.71013C12.612 8.72569 11.7888 9.54896 10.7732 9.54896C9.75769 9.54896 8.93442 8.72569 8.93442 7.71013C8.93442 6.69456 9.75769 5.87129 10.7732 5.87129Z"
        stroke={renderColor()}
        strokeWidth="1.1791"
      />
      <path
        d="M10.7643 1.49976C15.8809 1.49976 20.0287 5.64759 20.0287 10.7642C20.0287 13.0193 19.2229 15.0862 17.8837 16.6928L22.2533 21.0622C22.5822 21.3912 22.5822 21.9244 22.2533 22.2533C21.961 22.5457 21.5071 22.5782 21.1789 22.3508L21.0623 22.2533L16.6929 17.8836C15.0863 19.2229 13.0194 20.0286 10.7643 20.0286C5.64778 20.0286 1.5 15.8808 1.5 10.7642C1.5 5.64759 5.64778 1.49976 10.7643 1.49976ZM10.7643 3.1842C6.57806 3.1842 3.18442 6.57788 3.18442 10.7642C3.18442 14.9505 6.57806 18.3442 10.7643 18.3442C14.9506 18.3442 18.3442 14.9505 18.3442 10.7642C18.3442 6.57788 14.9506 3.1842 10.7643 3.1842Z"
        fill={renderColor()}
      />
    </svg>
  );
};

export const RenderIconSetting = (props: IIconProps) => {
  const renderColor = (): string => {
    if (!props.isActive && props.theme === ETheme.Dark) {
      return EThemeColor.ColorNeutralForeground1Dark;
    } else if (props.isActive && props.theme === ETheme.Dark) {
      return EThemeColor.ColorNeutralForeground2BrandSelectedDark;
    } else if (props.isActive) {
      return EThemeColor.ColorNeutralForeground2BrandSelectedLight;
    }
    return EThemeColor.IconLightGey;
  };

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.0127 2.25006C12.7466 2.25852 13.4777 2.34332 14.1942 2.5031C14.5069 2.57285 14.7408 2.83357 14.7763 3.15202L14.9465 4.67887C15.0235 5.37992 15.6155 5.9109 16.3211 5.91164C16.5108 5.91194 16.6984 5.87244 16.8737 5.79489L18.2743 5.17962C18.5656 5.05165 18.906 5.12142 19.1234 5.35368C20.1356 6.4347 20.8894 7.73121 21.3282 9.14564C21.4228 9.45064 21.3139 9.78209 21.0568 9.97156L19.8154 10.8867C19.4612 11.1469 19.2521 11.5601 19.2521 11.9995C19.2521 12.439 19.4612 12.8522 19.8161 13.113L21.0587 14.0284C21.3158 14.2178 21.4248 14.5493 21.3302 14.8544C20.8916 16.2685 20.1382 17.565 19.1266 18.6462C18.9093 18.8784 18.5693 18.9483 18.278 18.8207L16.8716 18.2046C16.4693 18.0285 16.0072 18.0543 15.627 18.274C15.2468 18.4938 14.9938 18.8813 14.9454 19.3178L14.7764 20.8445C14.7415 21.1593 14.5126 21.4182 14.2045 21.4916C12.7561 21.8362 11.247 21.8362 9.79852 21.4916C9.49039 21.4182 9.26153 21.1593 9.22667 20.8445L9.05785 19.32C9.00826 18.8843 8.75483 18.498 8.37491 18.279C7.995 18.06 7.53369 18.0344 7.13269 18.2094L5.72606 18.8257C5.43471 18.9534 5.09452 18.8833 4.87727 18.651C3.86511 17.5685 3.11168 16.2706 2.67369 14.8549C2.57935 14.5499 2.68835 14.2187 2.94533 14.0294L4.18867 13.1134C4.54281 12.8532 4.75196 12.44 4.75196 12.0005C4.75196 11.5611 4.54281 11.1479 4.1882 10.8873L2.94565 9.97291C2.68828 9.78351 2.57918 9.45184 2.67386 9.14664C3.11261 7.73221 3.86643 6.4357 4.87861 5.35468C5.09608 5.12242 5.43643 5.05265 5.72773 5.18062L7.12811 5.79579C7.53105 5.97262 7.99429 5.94591 8.37626 5.72275C8.75658 5.50215 9.00977 5.11428 9.05866 4.6777L9.22873 3.15202C9.26425 2.83341 9.49835 2.5726 9.81129 2.503C10.5286 2.34348 11.2604 2.25871 12.0127 2.25006ZM12.0128 3.74996C11.5588 3.75531 11.106 3.79449 10.6583 3.86708L10.5494 4.84425C10.4476 5.75374 9.92052 6.56108 9.13091 7.01909C8.33646 7.48323 7.36785 7.53909 6.52507 7.16923L5.62678 6.77462C5.05485 7.46879 4.59963 8.25141 4.27901 9.09174L5.07681 9.67885C5.81562 10.2217 6.25196 11.0837 6.25196 12.0005C6.25196 12.9173 5.81562 13.7794 5.07759 14.3216L4.27853 14.9103C4.59887 15.7521 5.05417 16.5362 5.62649 17.2317L6.53162 16.8351C7.36971 16.4692 8.33173 16.5228 9.12402 16.9795C9.9163 17.4362 10.4448 18.2418 10.5485 19.1527L10.6574 20.1366C11.5471 20.2878 12.4559 20.2878 13.3456 20.1366L13.4545 19.1527C13.5553 18.2421 14.0832 17.4337 14.8765 16.9753C15.6697 16.5169 16.6337 16.4631 17.4733 16.8305L18.3777 17.2268C18.9495 16.5323 19.4046 15.7495 19.7252 14.909L18.9272 14.3212C18.1884 13.7784 17.7521 12.9163 17.7521 11.9995C17.7521 11.0827 18.1884 10.2207 18.9263 9.67853L19.7232 9.09116C19.4026 8.25067 18.9473 7.4679 18.3753 6.77362L17.4788 7.16743C17.1134 7.32907 16.7183 7.41226 16.3192 7.41164C14.8495 7.4101 13.616 6.30361 13.4556 4.84389L13.3467 3.86676C12.9012 3.79426 12.4531 3.75518 12.0128 3.74996ZM12.0002 8.25001C14.0713 8.25001 15.7502 9.92894 15.7502 12C15.7502 14.0711 14.0713 15.75 12.0002 15.75C9.92912 15.75 8.25018 14.0711 8.25018 12C8.25018 9.92894 9.92912 8.25001 12.0002 8.25001ZM12.0002 9.75001C10.7575 9.75001 9.75018 10.7574 9.75018 12C9.75018 13.2427 10.7575 14.25 12.0002 14.25C13.2428 14.25 14.2502 13.2427 14.2502 12C14.2502 10.7574 13.2428 9.75001 12.0002 9.75001Z"
        fill={renderColor()}
      />
    </svg>
  );
};

export const RenderAssistantOrganizer = (props: IIconProps) => {
  const renderColor = (): string => {
    if (!props.isActive && props.theme === ETheme.Dark) {
      return EThemeColor.ColorNeutralForeground1Dark;
    } else if (props.isActive && props.theme === ETheme.Dark) {
      return EThemeColor.ColorNeutralForeground2BrandSelectedDark;
    } else if (props.isActive) {
      return EThemeColor.ColorNeutralForeground2BrandSelectedLight;
    }
    return EThemeColor.IconLightGey;
  };

  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 0C4.79086 0 3 1.79086 3 4C3 6.20914 4.79086 8 7 8C9.20914 8 11 6.20914 11 4C11 1.79086 9.20914 0 7 0ZM2.00873 9C0.903151 9 0 9.88687 0 11C0 12.6912 0.83281 13.9663 2.13499 14.7966C3.41697 15.614 5.14526 16 7 16C7.11209 16 7.22372 15.9986 7.33481 15.9958C7.1201 15.5422 7 15.0351 7 14.5C7 12.567 8.567 11 10.5 11L14 11C14 9.89557 13.1045 9.00001 12 9.00001L2.00873 9ZM10.5 12C9.11929 12 8 13.1193 8 14.5C8 15.8807 9.11929 17 10.5 17H11C11.2761 17 11.5 16.7761 11.5 16.5C11.5 16.2239 11.2761 16 11 16H10.5C9.67157 16 9 15.3284 9 14.5C9 13.6716 9.67157 13 10.5 13H11C11.2761 13 11.5 12.7761 11.5 12.5C11.5 12.2239 11.2761 12 11 12H10.5ZM14 12C13.7239 12 13.5 12.2239 13.5 12.5C13.5 12.7761 13.7239 13 14 13H14.5C15.3284 13 16 13.6716 16 14.5C16 15.3284 15.3284 16 14.5 16H14C13.7239 16 13.5 16.2239 13.5 16.5C13.5 16.7761 13.7239 17 14 17H14.5C15.8807 17 17 15.8807 17 14.5C17 13.1193 15.8807 12 14.5 12H14ZM10 14.5C10 14.2239 10.2239 14 10.5 14H14.5C14.7761 14 15 14.2239 15 14.5C15 14.7761 14.7761 15 14.5 15H10.5C10.2239 15 10 14.7761 10 14.5Z"
        fill="#106EBE"
      />
    </svg>
  );
};

export const SearchIcon = (props: IIconProps) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.30887 10.016C8.53903 10.6318 7.56252 11 6.5 11C4.01472 11 2 8.98531 2 6.50002C2 4.01473 4.01472 2 6.5 2C8.98528 2 11 4.01473 11 6.50002C11 7.56252 10.6318 8.53901 10.016 9.30885L13.8536 13.1464C14.0488 13.3417 14.0488 13.6583 13.8536 13.8536C13.6583 14.0488 13.3417 14.0488 13.1464 13.8536L9.30887 10.016ZM10 6.50002C10 4.56701 8.433 3 6.5 3C4.567 3 3 4.56701 3 6.50002C3 8.43302 4.567 10 6.5 10C8.433 10 10 8.43302 10 6.50002Z"
        fill={props.theme === ETheme.Dark ? "white" : "#212121"}
      />
    </svg>
  );
};

export const RenderListIcon = (props: IIconProps) => {
  const renderColor = (): string => {
    if (!props.isActive && props.theme === ETheme.Dark) {
      return EThemeColor.ColorNeutralForeground1Dark;
    } else if (props.isActive && props.theme === ETheme.Dark) {
      return EThemeColor.ColorNeutralForeground2BrandSelectedDark;
    } else if (props.isActive) {
      return EThemeColor.ColorNeutralForeground2BrandSelectedLight;
    }
    return EThemeColor.IconLightGey;
  };

  return props.isActive ? (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.3999 4.00015C2.3999 3.11649 3.11625 2.40015 3.9999 2.40015H11.9999C12.8836 2.40015 13.5999 3.11649 13.5999 4.00015V7.6C13.2656 7.34892 12.8501 7.20015 12.3999 7.20015H10.7999C10.1456 7.20015 9.56464 7.51437 9.19976 8.00015H7.5999C7.37899 8.00015 7.1999 8.17923 7.1999 8.40015C7.1999 8.62106 7.37899 8.80015 7.5999 8.80015H8.83991C8.83765 8.81128 8.83548 8.82245 8.83341 8.83365C7.90387 9.0058 7.1999 9.82076 7.1999 10.8001V13.6001H3.9999C3.11625 13.6001 2.3999 12.8838 2.3999 12.0001V4.00015ZM5.3999 6.40015C5.73127 6.40015 5.9999 6.13152 5.9999 5.80015C5.9999 5.46878 5.73127 5.20015 5.3999 5.20015C5.06853 5.20015 4.7999 5.46878 4.7999 5.80015C4.7999 6.13152 5.06853 6.40015 5.3999 6.40015ZM4.7999 8.20015C4.7999 8.53152 5.06853 8.80015 5.3999 8.80015C5.73127 8.80015 5.9999 8.53152 5.9999 8.20015C5.9999 7.86878 5.73127 7.60015 5.3999 7.60015C5.06853 7.60015 4.7999 7.86878 4.7999 8.20015ZM5.3999 11.2001C5.73127 11.2001 5.9999 10.9315 5.9999 10.6001C5.9999 10.2688 5.73127 10.0001 5.3999 10.0001C5.06853 10.0001 4.7999 10.2688 4.7999 10.6001C4.7999 10.9315 5.06853 11.2001 5.3999 11.2001ZM10.7999 5.60015H7.5999C7.37899 5.60015 7.1999 5.77923 7.1999 6.00015C7.1999 6.22106 7.37899 6.40015 7.5999 6.40015H10.7999C11.0208 6.40015 11.1999 6.22106 11.1999 6.00015C11.1999 5.77923 11.0208 5.60015 10.7999 5.60015ZM9.5999 9.60015V9.20015C9.5999 8.5374 10.1372 8.00015 10.7999 8.00015H12.3999C13.0626 8.00015 13.5999 8.5374 13.5999 9.20015V9.60015H13.9999C14.6626 9.60015 15.1999 10.1374 15.1999 10.8001V12.0001H13.5999V11.6001C13.5999 11.3792 13.4208 11.2001 13.1999 11.2001C12.979 11.2001 12.7999 11.3792 12.7999 11.6001V12.0001H10.3999V11.6001C10.3999 11.3792 10.2208 11.2001 9.9999 11.2001C9.77899 11.2001 9.5999 11.3792 9.5999 11.6001V12.0001H7.9999V10.8001C7.9999 10.1374 8.53716 9.60015 9.1999 9.60015H9.5999ZM10.3999 9.20015V9.60015H12.7999V9.20015C12.7999 8.97923 12.6208 8.80015 12.3999 8.80015H10.7999C10.579 8.80015 10.3999 8.97923 10.3999 9.20015ZM13.5999 12.8001H15.1999V14.0001C15.1999 14.6629 14.6626 15.2001 13.9999 15.2001H9.1999C8.53716 15.2001 7.9999 14.6629 7.9999 14.0001V12.8001H9.5999V13.2001C9.5999 13.4211 9.77899 13.6001 9.9999 13.6001C10.2208 13.6001 10.3999 13.4211 10.3999 13.2001V12.8001H12.7999V13.2001C12.7999 13.4211 12.979 13.6001 13.1999 13.6001C13.4208 13.6001 13.5999 13.4211 13.5999 13.2001V12.8001Z"
        fill={renderColor()}
      />
    </svg>
  ) : (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.4999 13.6001H7.6999V12.8001H4.4999C4.05807 12.8001 3.6999 12.442 3.6999 12.0001V4.00015C3.6999 3.55832 4.05807 3.20015 4.4999 3.20015H12.4999C12.9417 3.20015 13.2999 3.55832 13.2999 4.00015V7.24015C13.5955 7.30015 13.8673 7.42531 14.0999 7.6V4.00015C14.0999 3.11649 13.3836 2.40015 12.4999 2.40015H4.4999C3.61625 2.40015 2.8999 3.11649 2.8999 4.00015V12.0001C2.8999 12.8838 3.61625 13.6001 4.4999 13.6001ZM8.0999 8.80015H9.33991C9.3999 8.5046 9.52507 8.23271 9.69976 8.00015H8.0999C7.87899 8.00015 7.6999 8.17923 7.6999 8.40015C7.6999 8.62106 7.87899 8.80015 8.0999 8.80015ZM6.4999 5.80015C6.4999 6.13152 6.23127 6.40015 5.8999 6.40015C5.56853 6.40015 5.2999 6.13152 5.2999 5.80015C5.2999 5.46878 5.56853 5.20015 5.8999 5.20015C6.23127 5.20015 6.4999 5.46878 6.4999 5.80015ZM6.4999 8.20015C6.4999 8.53152 6.23127 8.80015 5.8999 8.80015C5.56853 8.80015 5.2999 8.53152 5.2999 8.20015C5.2999 7.86878 5.56853 7.60015 5.8999 7.60015C6.23127 7.60015 6.4999 7.86878 6.4999 8.20015ZM5.8999 11.2001C6.23127 11.2001 6.4999 10.9315 6.4999 10.6001C6.4999 10.2688 6.23127 10.0001 5.8999 10.0001C5.56853 10.0001 5.2999 10.2688 5.2999 10.6001C5.2999 10.9315 5.56853 11.2001 5.8999 11.2001ZM7.6999 6.00015C7.6999 5.77923 7.87899 5.60015 8.0999 5.60015H11.2999C11.5208 5.60015 11.6999 5.77923 11.6999 6.00015C11.6999 6.22106 11.5208 6.40015 11.2999 6.40015H8.0999C7.87899 6.40015 7.6999 6.22106 7.6999 6.00015ZM10.0999 9.60015V9.20015C10.0999 8.5374 10.6372 8.00015 11.2999 8.00015H12.8999C13.5626 8.00015 14.0999 8.5374 14.0999 9.20015V9.60015H14.4999C15.1626 9.60015 15.6999 10.1374 15.6999 10.8001V12.0001H14.0999V11.6001C14.0999 11.3792 13.9208 11.2001 13.6999 11.2001C13.479 11.2001 13.2999 11.3792 13.2999 11.6001V12.0001H10.8999V11.6001C10.8999 11.3792 10.7208 11.2001 10.4999 11.2001C10.279 11.2001 10.0999 11.3792 10.0999 11.6001V12.0001H8.4999V10.8001C8.4999 10.1374 9.03716 9.60015 9.6999 9.60015H10.0999ZM10.8999 9.20015V9.60015H13.2999V9.20015C13.2999 8.97923 13.1208 8.80015 12.8999 8.80015H11.2999C11.079 8.80015 10.8999 8.97923 10.8999 9.20015ZM14.0999 12.8001H15.6999V14.0001C15.6999 14.6629 15.1626 15.2001 14.4999 15.2001H9.6999C9.03716 15.2001 8.4999 14.6629 8.4999 14.0001V12.8001H10.0999V13.2001C10.0999 13.4211 10.279 13.6001 10.4999 13.6001C10.7208 13.6001 10.8999 13.4211 10.8999 13.2001V12.8001H13.2999V13.2001C13.2999 13.4211 13.479 13.6001 13.6999 13.6001C13.9208 13.6001 14.0999 13.4211 14.0999 13.2001V12.8001Z"
        fill={renderColor()}
      />
    </svg>
  );
};

export const RenderMapIcon = (props: IIconProps) => {
  const renderColor = (): string => {
    if (!props.isActive && props.theme === ETheme.Dark) {
      return EThemeColor.ColorNeutralForeground1Dark;
    } else if (props.isActive && props.theme === ETheme.Dark) {
      return EThemeColor.ColorNeutralForeground2BrandSelectedDark;
    } else if (props.isActive) {
      return EThemeColor.ColorNeutralForeground2BrandSelectedLight;
    }
    return EThemeColor.IconLightGey;
  };

  return props.isActive ? (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.1041 13.4377L6.9001 11.6577V2.59189L10.1004 4.83213L10.1041 13.4377ZM10.9041 13.4242L14.7059 11.1431C14.8264 11.0709 14.9001 10.9407 14.9001 10.8001V2.80015C14.9001 2.651 14.8171 2.51424 14.6848 2.44536C14.5525 2.37648 14.3929 2.38692 14.2707 2.47245L10.9004 4.83164L10.9041 13.4242ZM2.27071 5.27245L6.1001 2.59189V11.6577L2.69435 13.5498C2.57046 13.6186 2.4194 13.6168 2.29725 13.5449C2.1751 13.473 2.1001 13.3419 2.1001 13.2001V5.60015C2.1001 5.46962 2.16378 5.34731 2.27071 5.27245Z"
        fill={renderColor()}
      />
    </svg>
  ) : (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.6848 2.44536C14.8171 2.51424 14.9001 2.651 14.9001 2.80015V10.8001C14.9001 10.9407 14.8264 11.0709 14.7059 11.1431L10.7059 13.5431C10.5833 13.6167 10.4308 13.6192 10.3058 13.5498L6.69703 11.5449C6.56726 11.4685 6.42843 11.4695 6.30609 11.543L6.29435 11.5498L2.69435 13.5498C2.57046 13.6186 2.4194 13.6168 2.29725 13.5449C2.1751 13.473 2.1001 13.3419 2.1001 13.2001V5.60015C2.1001 5.46962 2.16378 5.34731 2.27071 5.27245L6.27071 2.47245C6.40844 2.37605 6.59175 2.37605 6.72948 2.47245L10.5001 5.11189L14.2707 2.47245C14.3929 2.38692 14.5525 2.37648 14.6848 2.44536ZM2.9001 5.80841V12.5203L5.90049 10.8535C5.96521 10.8151 6.03199 10.7835 6.1001 10.7585V3.56841L2.9001 5.80841ZM7.09835 10.8527L10.103 12.522L10.1002 5.80847L6.9001 3.56841V10.7594C6.96791 10.7842 7.03425 10.8153 7.09835 10.8527ZM10.903 12.4919L14.1001 10.5737V3.56841L10.9002 5.80835L10.903 12.4919Z"
        fill={renderColor()}
      />
    </svg>
  );
};

export const RenderIconEarth = (props: IIconProps) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.98747 2.17997C5.71458 2.84269 5.48643 3.62692 5.31842 4.5H10.6816C10.5136 3.62692 10.2854 2.84269 10.0125 2.17997C9.71058 1.44666 9.3637 0.88614 9.00409 0.51675C8.64602 0.148942 8.30689 0 8 0C7.69311 0 7.35398 0.148942 6.99591 0.51675C6.6363 0.88614 6.28942 1.44666 5.98747 2.17997ZM5.89053 0.281044C5.57693 0.707246 5.30036 1.22224 5.06279 1.79922C4.74205 2.57814 4.48315 3.49258 4.3012 4.5H0.804233C1.80285 2.45074 3.65108 0.891625 5.89053 0.281044ZM10.1095 0.281046C10.4231 0.707248 10.6996 1.22225 10.9372 1.79922C11.2579 2.57814 11.5169 3.49258 11.6988 4.5H15.1958C14.1972 2.45074 12.3489 0.891627 10.1095 0.281046ZM15.6016 5.5H11.85C11.9479 6.2949 12 7.13416 12 8C12 8.86584 11.9479 9.7051 11.85 10.5H15.6016C15.8601 9.71345 16 8.87306 16 8C16 7.12694 15.8601 6.28655 15.6016 5.5ZM15.1958 11.5H11.6988C11.5169 12.5074 11.2579 13.4219 10.9372 14.2008C10.6996 14.7778 10.4231 15.2928 10.1095 15.719C12.3489 15.1084 14.1972 13.5493 15.1958 11.5ZM8 16C8.30689 16 8.64602 15.8511 9.00409 15.4832C9.3637 15.1139 9.71058 14.5533 10.0125 13.82C10.2854 13.1573 10.5136 12.3731 10.6816 11.5H5.31842C5.48643 12.3731 5.71458 13.1573 5.98747 13.82C6.28942 14.5533 6.6363 15.1139 6.99591 15.4832C7.35398 15.8511 7.69311 16 8 16ZM5.89053 15.719C3.65107 15.1084 1.80285 13.5493 0.804233 11.5H4.3012C4.48315 12.5074 4.74205 13.4219 5.06279 14.2008C5.30036 14.7778 5.57693 15.2928 5.89053 15.719ZM0.398379 10.5H4.14996C4.0521 9.7051 4 8.86584 4 8C4 7.13416 4.0521 6.2949 4.14996 5.5H0.398379C0.139853 6.28655 0 7.12694 0 8C0 8.87306 0.139853 9.71345 0.398379 10.5ZM5 8C5 7.1253 5.0557 6.28549 5.15793 5.5H10.8421C10.9443 6.28549 11 7.1253 11 8C11 8.8747 10.9443 9.71451 10.8421 10.5H5.15793C5.0557 9.71451 5 8.8747 5 8Z"
        fill={renderColorPrimary(props.theme)}
      />
    </svg>
  );
};

export const RenderIconTime = (props: IIconProps) => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0ZM7.5 3C7.22386 3 7 3.22386 7 3.5V8.5L7.00806 8.58988C7.05039 8.82312 7.25454 9 7.5 9H10.5L10.5899 8.99194C10.8231 8.94961 11 8.74546 11 8.5C11 8.22386 10.7761 8 10.5 8H8V3.5L7.99194 3.41012C7.94961 3.17688 7.74546 3 7.5 3Z"
        fill="#106EBE"
      />
    </svg>
  );
};

export const RenderIconPre = (props: IIconProps) => {
  return (
    <svg
      className="floor-plan-arrow-left"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 8.00025C14 8.41446 13.6642 8.75025 13.25 8.75025L4.46302 8.75025L7.75009 11.6913C8.05878 11.9675 8.08512 12.4416 7.80893 12.7503C7.53273 13.059 7.05859 13.0854 6.7499 12.8092L1.9999 8.55918C1.84089 8.4169 1.75 8.21362 1.75 8.00025C1.75 7.78687 1.84089 7.5836 1.9999 7.44132L6.7499 3.19132C7.05859 2.91513 7.53273 2.94147 7.80893 3.25015C8.08512 3.55884 8.05878 4.03298 7.75009 4.30918L4.46302 7.25025L13.25 7.25025C13.6642 7.25025 14 7.58603 14 8.00025Z"
        fill={renderColorPrimary(props.theme)}
      />
    </svg>
  );
};

export const RenderIconNext = (props: IIconProps) => {
  return (
    <svg
      className="floor-plan-arrow-right"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 8.00025C2 8.41446 2.33579 8.75025 2.75 8.75025L11.537 8.75025L8.24991 11.6913C7.94122 11.9675 7.91488 12.4416 8.19107 12.7503C8.46727 13.059 8.94141 13.0854 9.2501 12.8092L14.0001 8.55918C14.1591 8.4169 14.25 8.21362 14.25 8.00025C14.25 7.78687 14.1591 7.5836 14.0001 7.44132L9.2501 3.19132C8.94141 2.91513 8.46727 2.94147 8.19107 3.25015C7.91488 3.55884 7.94122 4.03298 8.24991 4.30918L11.537 7.25025L2.75 7.25025C2.33579 7.25025 2 7.58603 2 8.00025Z"
        fill={renderColorPrimary(props.theme)}
      />
    </svg>
  );
};

export const RenderIconZoom = (props: IIconProps) => {
  return (
    <svg
      className="floor-floor-zoom-fit"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_822_22605)">
        <path
          d="M3.85987 7.84717C4.05152 7.64837 4.04573 7.33184 3.84693 7.14018C3.64813 6.94853 3.3316 6.95432 3.13994 7.15312L1.39863 8.95934C0.838638 9.54021 0.838456 10.46 1.39821 11.0411L3.13883 12.848C3.3304 13.0469 3.64693 13.0528 3.84581 12.8612C4.04469 12.6696 4.05061 12.3531 3.85903 12.1542L2.11842 10.3473C1.93183 10.1536 1.93189 9.84702 2.11855 9.6534L3.85987 7.84717ZM7.1519 3.14116C6.9531 3.33282 6.94731 3.64935 7.13897 3.84815C7.33062 4.04695 7.64715 4.05274 7.84595 3.86108L9.65216 2.11978C9.84586 1.93304 10.1526 1.93306 10.3463 2.11983L12.1518 3.86103C12.3506 4.05272 12.6672 4.04697 12.8588 3.8482C13.0505 3.64943 13.0448 3.3329 12.846 3.14121L11.0404 1.4C10.4594 0.839706 9.5392 0.839639 8.95811 1.39985L7.1519 3.14116ZM16.8589 7.15312C16.6672 6.95432 16.3507 6.94853 16.1519 7.14018C15.9531 7.33184 15.9473 7.64837 16.139 7.84717L17.8851 9.65836C18.0721 9.85241 18.0717 10.1598 17.8842 10.3534L16.1399 12.1531C15.9477 12.3514 15.9527 12.668 16.151 12.8602C16.3493 13.0524 16.6658 13.0474 16.858 12.8491L18.6022 11.0493C19.165 10.4687 19.1662 9.54644 18.605 8.96431L16.8589 7.15312ZM7.84581 16.141C7.64693 15.9494 7.33041 15.9554 7.13883 16.1542C6.94725 16.3531 6.95317 16.6696 7.15204 16.8612L8.96364 18.6063C9.54581 19.1672 10.4677 19.1658 11.0482 18.6032L12.8469 16.8602C13.0452 16.668 13.0502 16.3515 12.858 16.1532C12.6658 15.9549 12.3493 15.9499 12.151 16.1421L10.3523 17.8851C10.1588 18.0726 9.85147 18.0731 9.65741 17.8861L7.84581 16.141ZM7.9999 6.00014C6.89533 6.00014 5.9999 6.89558 5.9999 8.00014V12.0001C5.9999 13.1047 6.89533 14.0001 7.9999 14.0001H11.9999C13.1045 14.0001 13.9999 13.1047 13.9999 12.0001V8.00014C13.9999 6.89558 13.1045 6.00014 11.9999 6.00014H7.9999ZM6.9999 8.00014C6.9999 7.44786 7.44762 7.00014 7.9999 7.00014H11.9999C12.5522 7.00014 12.9999 7.44786 12.9999 8.00014V12.0001C12.9999 12.5524 12.5522 13.0001 11.9999 13.0001H7.9999C7.44762 13.0001 6.9999 12.5524 6.9999 12.0001V8.00014Z"
          fill={renderColorPrimary(props.theme)}
        />
      </g>
      <defs>
        <clipPath id="clip0_822_22605">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(0 0.000244141)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const RenderIconPermissionRed = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 2.5C4.67188 2.5 2 5.19531 2 8.5C2 11.8281 4.67188 14.5 8 14.5C11.3047 14.5 14 11.8281 14 8.5C14 5.19531 11.3047 2.5 8 2.5ZM3.125 8.5C3.125 7.375 3.5 6.32031 4.17969 5.5L11.0234 12.3438C10.1797 12.9766 9.125 13.375 8 13.375C5.30469 13.375 3.125 11.1953 3.125 8.5ZM11.7969 11.5234L4.97656 4.70312C5.79688 4.02344 6.85156 3.625 8 3.625C10.6719 3.625 12.875 5.82812 12.875 8.5C12.875 9.64844 12.4766 10.7031 11.7969 11.5234Z"
        fill="#C4314B"
      />
    </svg>
  );
};

export const RenderIconPermissionInfo = (props: IIconProps) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2ZM8.74905 5.50003C8.74905 5.91371 8.41369 6.24907 8.00001 6.24907C7.58633 6.24907 7.25098 5.91371 7.25098 5.50003C7.25098 5.08635 7.58633 4.751 8.00001 4.751C8.41369 4.751 8.74905 5.08635 8.74905 5.50003ZM8 7C8.27614 7 8.5 7.22386 8.5 7.5V10.5C8.5 10.7761 8.27614 11 8 11C7.72386 11 7.5 10.7761 7.5 10.5V7.5C7.5 7.22386 7.72386 7 8 7Z"
        fill={renderColorPrimary(props.theme)}
      />
    </svg>
  );
};

export const RenderIconPermissionGreen = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2ZM8.74905 5.50003C8.74905 5.91371 8.41369 6.24907 8.00001 6.24907C7.58633 6.24907 7.25098 5.91371 7.25098 5.50003C7.25098 5.08635 7.58633 4.751 8.00001 4.751C8.41369 4.751 8.74905 5.08635 8.74905 5.50003ZM8 7C8.27614 7 8.5 7.22386 8.5 7.5V10.5C8.5 10.7761 8.27614 11 8 11C7.72386 11 7.5 10.7761 7.5 10.5V7.5C7.5 7.22386 7.72386 7 8 7Z"
        fill="#05b04f"
      />
    </svg>
  );
};

export const RenderIconPermissionDelegate = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.5625 4.375C11.4688 4.375 11.375 4.39844 11.2812 4.39844C11.0469 3.74219 10.4141 3.25 9.6875 3.25C9.52344 3.25 9.38281 3.27344 9.24219 3.32031C8.9375 2.82812 8.39844 2.5 7.8125 2.5C7.20312 2.5 6.66406 2.82812 6.35938 3.32031C6.21875 3.27344 6.07812 3.25 5.9375 3.25C5 3.25 4.25 4.02344 4.25 4.9375V7.79688C4.10938 7.77344 3.99219 7.75 3.875 7.75C2.84375 7.75 2 8.59375 2 9.64844C2 10.1172 2.16406 10.5625 2.49219 10.9141L4.39062 12.9531C5.30469 13.9375 6.61719 14.5 7.95312 14.5H8.72656C11.2109 14.5 13.25 12.4844 13.25 10V6.0625C13.25 5.14844 12.4766 4.375 11.5625 4.375ZM12.125 10C12.125 11.875 10.6016 13.375 8.75 13.375H7.95312C6.92188 13.375 5.9375 12.9531 5.21094 12.2031L3.35938 10.1875C3.19531 10.0234 3.125 9.83594 3.125 9.64844C3.125 9.13281 3.57031 8.89844 3.85156 8.89844C4.0625 8.89844 4.27344 8.99219 4.41406 9.15625L5.04688 9.8125C5.07031 9.83594 5.11719 9.85938 5.16406 9.85938C5.28125 9.85938 5.35156 9.78906 5.35156 9.67188V4.9375C5.35156 4.63281 5.60938 4.375 5.91406 4.375C6.21875 4.375 6.45312 4.63281 6.45312 4.9375V8.5C6.5 8.71094 6.66406 8.875 6.875 8.875C7.0625 8.875 7.22656 8.71094 7.22656 8.52344L7.25 4.1875C7.25 3.88281 7.48438 3.625 7.78906 3.625C8.09375 3.625 8.32812 3.88281 8.32812 4.1875V8.5C8.375 8.71094 8.53906 8.875 8.75 8.875C8.9375 8.875 9.10156 8.71094 9.10156 8.52344V4.96094C9.10156 4.65625 9.35938 4.39844 9.66406 4.39844C9.96875 4.39844 10.2031 4.65625 10.2031 4.96094V8.52344C10.25 8.71094 10.4141 8.875 10.625 8.875C10.8125 8.875 10.9766 8.71094 10.9766 8.52344V6.0625C10.9766 5.75781 11.2109 5.5 11.5156 5.5C11.8203 5.5 12.0547 5.75781 12.0547 6.0625V10H12.125Z"
        fill="#106EBE"
      />
    </svg>
  );
};

export const RenderIconPermissionRedFull = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2ZM8.74905 5.50003C8.74905 5.91371 8.41369 6.24907 8.00001 6.24907C7.58633 6.24907 7.25098 5.91371 7.25098 5.50003C7.25098 5.08635 7.58633 4.751 8.00001 4.751C8.41369 4.751 8.74905 5.08635 8.74905 5.50003ZM8 7C8.27614 7 8.5 7.22386 8.5 7.5V10.5C8.5 10.7761 8.27614 11 8 11C7.72386 11 7.5 10.7761 7.5 10.5V7.5C7.5 7.22386 7.72386 7 8 7Z"
        fill="#C4314B"
      />
    </svg>
  );
};

export const FilterResourceIcon = (props: IIconProps) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.25 13.5C12.6642 13.5 13 13.8358 13 14.25C13 14.6642 12.6642 15 12.25 15H7.75C7.33579 15 7 14.6642 7 14.25C7 13.8358 7.33579 13.5 7.75 13.5H12.25ZM14.25 9.25C14.6642 9.25 15 9.58579 15 10C15 10.4142 14.6642 10.75 14.25 10.75H5.75C5.33579 10.75 5 10.4142 5 10C5 9.58579 5.33579 9.25 5.75 9.25H14.25ZM16.25 5C16.6642 5 17 5.33579 17 5.75C17 6.16421 16.6642 6.5 16.25 6.5H3.75C3.33579 6.5 3 6.16421 3 5.75C3 5.33579 3.33579 5 3.75 5H16.25Z"
        fill={renderColorPrimary(props.theme)}
      />
    </svg>
  );
};

export const MapActiveIcon = (props: IIconProps) => {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.1041 13.4377L6.9001 11.6577V2.59189L10.1004 4.83213L10.1041 13.4377ZM10.9041 13.4242L14.7059 11.1431C14.8264 11.0709 14.9001 10.9407 14.9001 10.8001V2.80015C14.9001 2.651 14.8171 2.51424 14.6848 2.44536C14.5525 2.37648 14.3929 2.38692 14.2707 2.47245L10.9004 4.83164L10.9041 13.4242ZM2.27071 5.27245L6.1001 2.59189V11.6577L2.69435 13.5498C2.57046 13.6186 2.4194 13.6168 2.29725 13.5449C2.1751 13.473 2.1001 13.3419 2.1001 13.2001V5.60015C2.1001 5.46962 2.16378 5.34731 2.27071 5.27245Z"
        fill={renderColorPrimary(props.theme)}
      />
    </svg>
  );
};

export const MapActiveIconLocation = (props: IIconProps) => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.36847 2.33276L5.39592 2.33203L5.42261 2.33274C5.43569 2.33349 5.44881 2.33485 5.46191 2.33684L5.47129 2.33906C5.52111 2.34706 5.57062 2.36485 5.61781 2.39281L5.64807 2.41238L8.60577 4.49211L11.5615 2.41433C11.8344 2.22253 12.204 2.39492 12.2466 2.71129L12.2506 2.77224V8.97455C12.2506 9.09665 12.1997 9.2122 12.1117 9.29432L12.0647 9.33246L8.8564 11.5878C8.70071 11.6973 8.51349 11.6882 8.37351 11.6013L5.39568 9.50645L2.43837 11.5859C2.16554 11.7777 1.79586 11.6053 1.75331 11.2889L1.74927 11.228V5.02568C1.74927 4.90357 1.80022 4.78802 1.88817 4.70591L1.93516 4.66776L5.1435 2.41238C5.18083 2.38613 5.21998 2.36671 5.25986 2.35353L5.3313 2.3372L5.36847 2.33276ZM11.3756 3.61458L9.0423 5.25486V10.3876L11.3756 8.74732V3.61458ZM4.9576 3.61263L2.62427 5.25291V10.3856L4.9576 8.74537V3.61263ZM5.83396 3.61263V8.74537L8.1673 10.3856V5.25291L5.83396 3.61263Z"
        fill={renderColorPrimary(props.theme)}
      />
    </svg>
  );
};

export const AttendeeIcon = (props: IIconProps) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.5 4.5C12.5 5.88071 11.3807 7 10 7C8.61929 7 7.5 5.88071 7.5 4.5C7.5 3.11929 8.61929 2 10 2C11.3807 2 12.5 3.11929 12.5 4.5ZM17.5 5C17.5 6.10457 16.6046 7 15.5 7C14.3954 7 13.5 6.10457 13.5 5C13.5 3.89543 14.3954 3 15.5 3C16.6046 3 17.5 3.89543 17.5 5ZM4.5 7C5.60457 7 6.5 6.10457 6.5 5C6.5 3.89543 5.60457 3 4.5 3C3.39543 3 2.5 3.89543 2.5 5C2.5 6.10457 3.39543 7 4.5 7ZM6 9.25C6 8.55964 6.55964 8 7.25 8H12.75C13.4404 8 14 8.55964 14 9.25V14C14 16.2091 12.2091 18 10 18C7.79086 18 6 16.2091 6 14V9.25ZM5 9.25C5 8.78746 5.13957 8.35752 5.37889 8H3.25C2.55964 8 2 8.55964 2 9.25V13C2 14.6569 3.34315 16 5 16C5.13712 16 5.27209 15.9908 5.40434 15.973C5.14412 15.3677 5 14.7007 5 14V9.25ZM15 14C15 14.7007 14.8559 15.3677 14.5957 15.973C14.7279 15.9908 14.8629 16 15 16C16.6569 16 18 14.6569 18 13V9.25C18 8.55964 17.4404 8 16.75 8H14.6211C14.8604 8.35752 15 8.78746 15 9.25V14Z"
        fill={renderColorPrimary(props.theme)}
      />
    </svg>
  );
};

export const ResourceDetailNameIcon = (props: IIconProps) => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.66658 11.25C9.66658 11.4844 9.45825 11.6667 9.24992 11.6667H6.74992C6.51554 11.6667 6.33325 11.4844 6.33325 11.25V10H1.33325V13.75C1.33325 14.4271 1.90617 15 2.58325 15H13.4166C14.0676 15 14.6666 14.4271 14.6666 13.75V10H9.66658V11.25ZM13.4166 5H11.3333V3.75C11.3333 3.09896 10.7343 2.5 10.0833 2.5H5.91658C5.2395 2.5 4.66658 3.09896 4.66658 3.75V5H2.58325C1.90617 5 1.33325 5.59896 1.33325 6.25V9.16667H14.6666V6.25C14.6666 5.59896 14.0676 5 13.4166 5ZM10.0833 5H5.91658V3.75H10.0833V5Z"
        fill={props.color ? props.color : renderColorPrimary(props.theme)}
      />
    </svg>
  );
};

export const ResourceDetailLocationIcon = (props: IIconProps) => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.15573 15.0444C10.8991 13.5097 14 10.3756 14 7.5C14 4.18629 11.3137 1.5 8 1.5C4.68629 1.5 2 4.18629 2 7.5C2 10.3756 5.10094 13.5097 6.84427 15.0444C7.51146 15.6317 8.48854 15.6317 9.15573 15.0444ZM6 7.5C6 6.39543 6.89543 5.5 8 5.5C9.10457 5.5 10 6.39543 10 7.5C10 8.60457 9.10457 9.5 8 9.5C6.89543 9.5 6 8.60457 6 7.5Z"
        fill={props.color ? props.color : renderColorPrimary(props.theme)}
      />
    </svg>
  );
};

export const ResourceDetailEmailIcon = (props: IIconProps) => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 3.5C2.89543 3.5 2 4.39543 2 5.5V5.7013L8.0001 8.93212L14 5.70141V5.5C14 4.39543 13.1046 3.5 12 3.5H4ZM14 6.83716L8.23715 9.94024C8.08916 10.0199 7.91104 10.0199 7.76305 9.94024L2 6.83706V11.5C2 12.6046 2.89543 13.5 4 13.5H12C13.1046 13.5 14 12.6046 14 11.5V6.83716Z"
        fill={props.color ? props.color : renderColorPrimary(props.theme)}
      />
    </svg>
  );
};

export const TentativeIcon = (props: IIconProps) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.5625 4.375C11.4688 4.375 11.375 4.39844 11.2812 4.39844C11.0469 3.74219 10.4141 3.25 9.6875 3.25C9.52344 3.25 9.38281 3.27344 9.24219 3.32031C8.9375 2.82812 8.39844 2.5 7.8125 2.5C7.20312 2.5 6.66406 2.82812 6.35938 3.32031C6.21875 3.27344 6.07812 3.25 5.9375 3.25C5 3.25 4.25 4.02344 4.25 4.9375V7.79688C4.10938 7.77344 3.99219 7.75 3.875 7.75C2.84375 7.75 2 8.59375 2 9.64844C2 10.1172 2.16406 10.5625 2.49219 10.9141L4.39062 12.9531C5.30469 13.9375 6.61719 14.5 7.95312 14.5H8.72656C11.2109 14.5 13.25 12.4844 13.25 10V6.0625C13.25 5.14844 12.4766 4.375 11.5625 4.375ZM12.125 10C12.125 11.875 10.6016 13.375 8.75 13.375H7.95312C6.92188 13.375 5.9375 12.9531 5.21094 12.2031L3.35938 10.1875C3.19531 10.0234 3.125 9.83594 3.125 9.64844C3.125 9.13281 3.57031 8.89844 3.85156 8.89844C4.0625 8.89844 4.27344 8.99219 4.41406 9.15625L5.04688 9.8125C5.07031 9.83594 5.11719 9.85938 5.16406 9.85938C5.28125 9.85938 5.35156 9.78906 5.35156 9.67188V4.9375C5.35156 4.63281 5.60938 4.375 5.91406 4.375C6.21875 4.375 6.45312 4.63281 6.45312 4.9375V8.5C6.5 8.71094 6.66406 8.875 6.875 8.875C7.0625 8.875 7.22656 8.71094 7.22656 8.52344L7.25 4.1875C7.25 3.88281 7.48438 3.625 7.78906 3.625C8.09375 3.625 8.32812 3.88281 8.32812 4.1875V8.5C8.375 8.71094 8.53906 8.875 8.75 8.875C8.9375 8.875 9.10156 8.71094 9.10156 8.52344V4.96094C9.10156 4.65625 9.35938 4.39844 9.66406 4.39844C9.96875 4.39844 10.2031 4.65625 10.2031 4.96094V8.52344C10.25 8.71094 10.4141 8.875 10.625 8.875C10.8125 8.875 10.9766 8.71094 10.9766 8.52344V6.0625C10.9766 5.75781 11.2109 5.5 11.5156 5.5C11.8203 5.5 12.0547 5.75781 12.0547 6.0625V10H12.125Z"
        fill={renderColorPrimary(props.theme)}
      />
    </svg>
  );
};

export const ResourceTypeIcon = (props: IIconProps) => {
  const renderColor = (): string => {
    if (!props.isActive && props.theme === ETheme.Dark) {
      return EThemeColor.ColorNeutralForeground1Dark;
    } else if (props.isActive && props.theme === ETheme.Dark) {
      return EThemeColor.ColorNeutralForeground2BrandSelectedDark;
    } else if (props.isActive) {
      return EThemeColor.ColorNeutralForeground2BrandSelectedLight;
    }
    return EThemeColor.IconLightGey;
  };

  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.28513 1.84917C6.38649 1.76607 6.51977 1.73279 6.6483 1.7585L11.0233 2.6335C11.2278 2.6744 11.375 2.85396 11.375 3.0625V10.9348C11.375 11.1433 11.2278 11.3229 11.0233 11.3638L6.6483 12.2388C6.51977 12.2645 6.38649 12.2312 6.28513 12.1481C6.18377 12.065 6.125 11.9409 6.125 11.8098V2.1875M8.75 6.99861C8.75 6.75699 8.55412 6.56111 8.3125 6.56111C8.07088 6.56111 7.875 6.75699 7.875 6.99861C7.875 7.24024 8.07088 7.43611 8.3125 7.43611C8.55412 7.43611 8.75 7.24024 8.75 6.99861Z"
        fill={renderColor()}
      />
      <path
        d="M5.25 2.625H3.0625C2.82088 2.625 2.625 2.82088 2.625 3.0625V10.9348C2.625 11.1764 2.82088 11.3723 3.0625 11.3723H5.25V2.625Z"
        fill={renderColor()}
      />
      <path
        d="M6.28513 1.84917C6.18377 1.93226 6.125 2.05643 6.125 2.1875L6.28513 1.84917Z"
        fill={renderColor()}
      />
    </svg>
  );
};

export const NotifyIcon = ({ type }: { type?: ETypeNotify }) => {
  const renderIcon = (): JSX.Element => {
    switch (type) {
      case ETypeNotify.Error:
        return (
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10 2C14.4183 2 18 5.58172 18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10C2 5.58172 5.58172 2 10 2ZM10 3C6.13401 3 3 6.13401 3 10C3 13.866 6.13401 17 10 17C13.866 17 17 13.866 17 10C17 6.13401 13.866 3 10 3ZM7.80943 7.11372L7.87868 7.17157L10 9.29289L12.1213 7.17157C12.2949 6.99801 12.5643 6.97872 12.7592 7.11372L12.8284 7.17157C13.002 7.34514 13.0213 7.61456 12.8863 7.80943L12.8284 7.87868L10.7071 10L12.8284 12.1213C13.002 12.2949 13.0213 12.5643 12.8863 12.7592L12.8284 12.8284C12.6549 13.002 12.3854 13.0213 12.1906 12.8863L12.1213 12.8284L10 10.7071L7.87868 12.8284C7.70511 13.002 7.43569 13.0213 7.24082 12.8863L7.17157 12.8284C6.99801 12.6549 6.97872 12.3854 7.11372 12.1906L7.17157 12.1213L9.29289 10L7.17157 7.87868C6.99801 7.70511 6.97872 7.43569 7.11372 7.24082L7.17157 7.17157C7.34514 6.99801 7.61456 6.97872 7.80943 7.11372Z"
              fill="#C4314B"
            />
          </svg>
        );
      case ETypeNotify.Success:
        return (
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10 2C14.4183 2 18 5.58172 18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10C2 5.58172 5.58172 2 10 2ZM10 3C6.13401 3 3 6.13401 3 10C3 13.866 6.13401 17 10 17C13.866 17 17 13.866 17 10C17 6.13401 13.866 3 10 3ZM13.3584 7.64645C13.532 7.82001 13.5513 8.08944 13.4163 8.28431L13.3584 8.35355L9.35355 12.3584C9.17999 12.532 8.91056 12.5513 8.71569 12.4163L8.64645 12.3584L6.64645 10.3584C6.45118 10.1632 6.45118 9.84658 6.64645 9.65131C6.82001 9.47775 7.08944 9.45846 7.28431 9.59346L7.35355 9.65131L9 11.298L12.6513 7.64645C12.8466 7.45118 13.1632 7.45118 13.3584 7.64645Z"
              fill="#237B4B"
            />
          </svg>
        );

      default:
        return (
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10 2C14.4183 2 18 5.58172 18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10C2 5.58172 5.58172 2 10 2ZM10 3C6.13401 3 3 6.13401 3 10C3 13.866 6.13401 17 10 17C13.866 17 17 13.866 17 10C17 6.13401 13.866 3 10 3ZM10 12.5C10.4142 12.5 10.75 12.8358 10.75 13.25C10.75 13.6642 10.4142 14 10 14C9.58579 14 9.25 13.6642 9.25 13.25C9.25 12.8358 9.58579 12.5 10 12.5ZM10 6C10.2455 6 10.4496 6.17688 10.4919 6.41012L10.5 6.5V11C10.5 11.2761 10.2761 11.5 10 11.5C9.75454 11.5 9.55039 11.3231 9.50806 11.0899L9.5 11V6.5C9.5 6.22386 9.72386 6 10 6Z"
              fill="#A16114"
            />
          </svg>
        );
    }
  };
  return renderIcon();
};
